var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "#FFB300"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.88 42.83H312.58V45.77H303.88V42.83ZM304.39 49.97H313.93V53H300.61V35.84H313.6V38.9H304.39V49.97ZM315.437 53V35.84H318.557L328.907 48.38H327.497V35.84H331.247V53H328.127L317.777 40.46H319.217V53H315.437ZM337.342 42.83H346.042V45.77H337.342V42.83ZM337.852 49.97H347.392V53H334.072V35.84H347.062V38.9H337.852V49.97ZM348.898 53V35.84H356.308C357.848 35.84 359.178 36.09 360.298 36.59C361.418 37.07 362.278 37.77 362.878 38.69C363.498 39.61 363.808 40.72 363.808 42.02C363.808 43.3 363.498 44.4 362.878 45.32C362.278 46.24 361.418 46.94 360.298 47.42C359.178 47.9 357.848 48.14 356.308 48.14H350.998L352.678 46.49V53H348.898ZM360.058 53L355.648 46.76H359.728L364.138 53H360.058ZM352.678 46.94L351.298 45.17H356.038C357.358 45.17 358.348 44.9 359.008 44.36C359.668 43.8 359.998 43.02 359.998 42.02C359.998 41.02 359.668 40.25 359.008 39.71C358.348 39.17 357.358 38.9 356.038 38.9H351.298L352.678 37.16V46.94ZM380.6 51.11C380.02 51.57 379.35 51.97 378.59 52.31C377.85 52.63 377.07 52.87 376.25 53.03C375.43 53.21 374.6 53.3 373.76 53.3C371.92 53.3 370.27 52.92 368.81 52.16C367.37 51.38 366.24 50.32 365.42 48.98C364.6 47.64 364.19 46.12 364.19 44.42C364.19 42.72 364.6 41.21 365.42 39.89C366.24 38.55 367.36 37.5 368.78 36.74C370.22 35.96 371.85 35.57 373.67 35.57C375.27 35.57 376.67 35.81 377.87 36.29C379.07 36.75 380.07 37.47 380.87 38.45L378.41 40.82C377.79 40.12 377.09 39.61 376.31 39.29C375.53 38.95 374.67 38.78 373.73 38.78C372.63 38.78 371.64 39.02 370.76 39.5C369.9 39.98 369.22 40.65 368.72 41.51C368.24 42.35 368 43.32 368 44.42C368 45.52 368.25 46.5 368.75 47.36C369.25 48.22 369.94 48.89 370.82 49.37C371.7 49.85 372.71 50.09 373.85 50.09C374.75 50.09 375.57 49.95 376.31 49.67C377.07 49.39 377.78 48.97 378.44 48.41L380.6 51.11ZM377.03 51.14V44.27H380.6V51.11L377.03 51.14ZM387.117 53V46.1L387.837 48.5L380.157 35.84H384.177L390.177 45.62H388.077L394.077 35.84H397.917L390.237 48.5L390.927 46.1V53H387.117Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg55);
export default __webpack_public_path__ + "static/media/55.ca00951c75ea511662bc9cb7e66f4b60.svg";
export { ForwardRef as ReactComponent };